import api from 'service/api'

// Whatever the server sent is passed through as is, so every field is optional
// and has to be checked before use.
export type SsoCodeResult = {
  redirectUrl?: unknown
  unauthorized?: true
} | null

export const fetchSsoCode = async (baseUrl: string, authToken: string, communityId: number): Promise<SsoCodeResult> => {
  return api.requestServiceDeskSsoCode(baseUrl, authToken, communityId)
}
